var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraSoftwareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "4 4 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.914 15.337L16.572 4.994 15.577 4 7.82 11.757l-3.547 3.547c-.364.364-.364.961 0 1.359l7.094 7.094L15.577 28l7.757-7.757.133-.133 3.447-3.447a.94.94 0 000-1.326zm-11.337 4.21L12.03 16l3.547-3.547L19.124 16l-3.547 3.547z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.577 12.453c-2.32-2.32-2.32-6.1-.033-8.42L7.787 11.79l4.21 4.21 3.58-3.547z",
    fill: "url(#jira-software-icon_svg__paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.124 16l-3.547 3.547c2.32 2.32 2.32 6.1 0 8.453l7.79-7.79L19.124 16z",
    fill: "url(#jira-software-icon_svg__paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira-software-icon_svg__paint0_linear",
    x1: 14.945,
    y1: 8.86,
    x2: 9.991,
    y2: 13.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jira-software-icon_svg__paint1_linear",
    x1: 16.256,
    y1: 23.089,
    x2: 21.2,
    y2: 18.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
export default SvgJiraSoftwareIcon;